// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SimpleIntakeAccountContactPhonesModel {
    static getAttributeTypeMap() {
        return SimpleIntakeAccountContactPhonesModel.attributeTypeMap;
    }
}
SimpleIntakeAccountContactPhonesModel.discriminator = undefined;
SimpleIntakeAccountContactPhonesModel.additionalProperties = false;
SimpleIntakeAccountContactPhonesModel.attributeTypeMap = [
    {
        "name": "home",
        "baseName": "home",
        "type": "string"
    },
    {
        "name": "mobile",
        "baseName": "mobile",
        "type": "string"
    },
];
//# sourceMappingURL=simpleIntakeAccountContactPhonesModel.js.map